import { render, staticRenderFns } from "./OperacionesLayout.vue?vue&type=template&id=7883dbc5"
import script from "./OperacionesLayout.vue?vue&type=script&lang=ts"
export * from "./OperacionesLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports